import type { FaireProductEntity } from "../../entity_types/product";

export const p_j3r3rxkxuq: FaireProductEntity = {
  token: "p_j3r3rxkxuq",
  type: "product",
  name: "COIN POUCH FLOWER MARKET TULIP",
  brandToken: "b_3s38anh4bi",
  brandName: "Lady Jayne",
  imageUrl:
    "https://cdn.faire.com/fastly/16c897bee11dd4ab5abb828546d8d2997dc56ae3c06af4aa110814266fc6a043.jpeg",
  galleryImageUrls: [],
  priceDollars: 10.96,
  description:
    'Embroidered canvas pouch with lining and gold metal zipper pull.\n5" x 3.5"',
  tags: [],
  msrpDollars: 21.92,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:45.403Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
